export default __webpack_public_path__ + "static/media/music-room.e1c11d68.mp4";